<template>
  <div v-if="!loading">
    <v-container fluid>
      <v-row>
        <v-col v-if="'spravanie_vo_vtos_silne' in form" cols="6">
          <v-card>
            <v-app-bar dark color="red lighten-2">
              <v-icon>mdi-meditation</v-icon>&nbsp;
              <v-toolbar-title>Správanie vo VTOS</v-toolbar-title>
            </v-app-bar>

            <v-container>
              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Silné stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('spravanie_silne')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.spravanie_vo_vtos_silne" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Slabé stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('spravanie_slabe')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.spravanie_vo_vtos_slabe" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Príležitosti
                      <v-spacer />
                      <v-btn icon @click="showInfo('spravanie_prilezitosti')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.spravanie_vo_vtos_prilezitosti" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Ohrozenia
                      <v-spacer />
                      <v-btn icon @click="showInfo('spravanie_ohrozenia')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.spravanie_vo_vtos_ohrozenia" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>

        <v-col v-if="'rodina_silne' in form" cols="6">
          <v-card>
            <v-app-bar dark color="pink lighten-2">
              <v-icon>mdi-home-heart</v-icon>&nbsp;
              <v-toolbar-title>Rodina, vzťahy a komunita</v-toolbar-title>
            </v-app-bar>

            <v-container>
              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Silné stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('rodina_silne')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.rodina_silne" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Slabé stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('rodina_slabe')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.rodina_slabe" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Príležitosti
                      <v-spacer />
                      <v-btn icon @click="showInfo('rodina_prilezitosti')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.rodina_prilezitosti" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Ohrozenia
                      <v-spacer />
                      <v-btn icon @click="showInfo('rodina_ohrozenia')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.rodina_ohrozenia" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-card>
            <v-app-bar dark color="purple lighten-2">
              <v-icon>mdi-home-city</v-icon>&nbsp;
              <v-toolbar-title>Bývanie</v-toolbar-title>
            </v-app-bar>

            <v-container>
              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Silné stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('byvanie_silne')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.byvanie_silne" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Slabé stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('byvanie_slabe')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.byvanie_slabe" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Príležitosti
                      <v-spacer />
                      <v-btn icon @click="showInfo('byvanie_prilezitosti')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.byvanie_prilezitosti" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Ohrozenia
                      <v-spacer />
                      <v-btn icon @click="showInfo('byvanie_ohrozenia')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.byvanie_ohrozenia" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card>
            <v-app-bar dark color="deep-purple lighten-2">
              <v-icon>mdi-school</v-icon>&nbsp;
              <v-toolbar-title>Vzdelanie</v-toolbar-title>
            </v-app-bar>

            <v-container>
              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Silné stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('vzdelanie_silne')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.vzdelanie_silne" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Slabé stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('vzdelanie_slabe')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.vzdelanie_slabe" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Príležitosti
                      <v-spacer />
                      <v-btn icon @click="showInfo('vzdelanie_prilezitosti')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.vzdelanie_prilezitosti" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Ohrozenia
                      <v-spacer />
                      <v-btn icon @click="showInfo('vzdelanie_ohrozenia')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.vzdelanie_ohrozenia" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-card>
            <v-app-bar dark color="indigo lighten-2">
              <v-icon>mdi-account-hard-hat</v-icon>&nbsp;
              <v-toolbar-title>Zamestnanie</v-toolbar-title>
            </v-app-bar>

            <v-container>
              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Silné stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('zamestnanie_silne')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.zamestnanie_silne" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Slabé stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('zamestnanie_slabe')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.zamestnanie_slabe" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Príležitosti
                      <v-spacer />
                      <v-btn icon @click="showInfo('zamestnanie_prilezitosti')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.zamestnanie_prilezitosti" auto-grow dense rows="1" />
                    </v-card-text>
                    <v-card-text>
                      <div class="body-1" v-for="prilezitost in form.zamestnanie_prilezitosti_sp"
                        v-bind:key="prilezitost.id">
                        Príležitosť zamestnať sa v sociálnom podniku
                        {{ prilezitost.socialny_podnik.kontaktne_udaje_nazov }}
                      </div>
                      <!-- <v-textarea
                        v-model="form.zamestnanie_prilezitosti_sp"
                        auto-grow
                        dense
                        rows="1"
                      /> -->
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Ohrozenia
                      <v-spacer />
                      <v-btn icon @click="showInfo('zamestnanie_ohrozenia')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.zamestnanie_ohrozenia" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card>
            <v-app-bar dark color="blue lighten-2">
              <v-icon>mdi-cash</v-icon>&nbsp;
              <v-toolbar-title>Financie</v-toolbar-title>
            </v-app-bar>

            <v-container>
              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Silné stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('financie_silne')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.financie_silne" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Slabé stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('financie)slabe')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.financie_slabe" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Príležitosti
                      <v-spacer />
                      <v-btn icon @click="showInfo('financie_prilezitosti')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.financie_prilezitosti" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Ohrozenia
                      <v-spacer />
                      <v-btn icon @click="showInfo('financie_ohrozenia')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.financie_ohrozenia" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="6">
          <v-card>
            <v-app-bar dark color="light-blue lighten-2">
              <v-icon>mdi-soccer</v-icon>&nbsp;
              <v-toolbar-title>Voľný čas</v-toolbar-title>
            </v-app-bar>

            <v-container>
              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Silné stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('volny_cas_silne')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.volny_cas_silne" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-2" dark>
                    <v-card-title class="subtitle-1">
                      Slabé stránky
                      <v-spacer />
                      <v-btn icon @click="showInfo('volny_cas_slabe')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.volny_cas_slabe" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="6">
                  <v-card color="light-green lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Príležitosti
                      <v-spacer />
                      <v-btn icon @click="showInfo('volny_cas_prilezitosti')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.volny_cas_prilezitosti" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6">
                  <v-card color="deep-orange lighten-1" dark>
                    <v-card-title class="subtitle-1">
                      Ohrozenia
                      <v-spacer />
                      <v-btn icon @click="showInfo('volny_cas_ohrozenia')">
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </v-card-title>

                    <v-card-text>
                      <v-textarea v-model="form.volny_cas_ohrozenia" auto-grow dense rows="1" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card>
            <v-card-title>Sociálne podniky</v-card-title>
            <v-card-text>
              <v-row v-if="'socialny_podnik_dostupny' in form">
                <v-col>
                  <v-switch v-model="form.socialny_podnik_dostupny"
                    label="Klient je viditeľný v zozname pre sociálne podniky" />
                </v-col>
              </v-row>

              <v-row v-if="'pracovne_zrucnosti' in form">
                <v-col>
                  <v-textarea v-model="form.pracovne_zrucnosti"
                    label="Pracovné zručnosti (túto časť priamo vidia sociálne podniky)" auto-grow dense rows="1" />
                </v-col>
              </v-row>
              <v-row v-if="form.socialny_podnik_akceptovany">
                <v-col>
                  <v-alert type="success">
                    Klient akceptoval ponuku od:
                    <strong>{{ form.socialny_podnik_akceptovany.socialny_podnik.kontaktne_udaje_nazov }}</strong> -
                    {{ form.socialny_podnik_akceptovany.socialny_podnik.miesto_cinnosti_a_aktivit }} -
                    {{ form.socialny_podnik_akceptovany.socialny_podnik.email }}
                  </v-alert>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <h3>
                    Zoznam sociálnych podnikov, ktoré prejavili záujem o
                    zamestnanie klienta
                  </h3>

                  <v-data-table :headers="socialne_podniky_headers" :items="form.socialne_podniky"
                    :expanded.sync="expanded" item-key="id" show-expand class="elevation-1">

                    <template v-slot:item.socialny_podnik.ubytovanie="{ item }">
                      <v-tooltip top v-if="item.socialny_podnik.ubytovanie">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-home
                          </v-icon>
                        </template>
                        <span>Ubytovanie</span>
                      </v-tooltip>

                      <v-tooltip top v-if="item.socialny_podnik.doprava">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-bus
                          </v-icon>
                        </template>
                        <span>Doprava</span>
                      </v-tooltip>

                      <v-tooltip top v-if="item.socialny_podnik.financne_zalohy">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-cash
                          </v-icon>
                        </template>
                        <span>Finančné zálohy</span>
                      </v-tooltip>

                      <v-tooltip top v-if="item.socialny_podnik.mentoring">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-account-eye
                          </v-icon>
                        </template>
                        <span>Mentoring</span>
                      </v-tooltip>

                      <v-tooltip top v-if="item.socialny_podnik.rekvalifikacia">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-school
                          </v-icon>
                        </template>
                        <span>Rekvalifikácia</span>
                      </v-tooltip>

                    </template>
                    <template v-slot:item.id="{ item }">
                      <v-btn v-if="item.status == 'Nový'" small color="success"
                        @click="acceptItem(item)">Akceptovať</v-btn>
                      <v-btn v-if="item.status == 'Nový'" small color="error" @click="rejectItem(item)">Odmietnuť</v-btn>
                      <v-btn v-if="item.status == 'Akceptovaný'" small color="error"
                        @click="rejectItem(item)">Odmietnuť</v-btn>
                      <v-btn v-if="item.status == 'Odmietnutý'" small color="success"
                        @click="acceptItem(item)">Akceptovať</v-btn>
                    </template>

                    <template v-slot:item.created_at="{ item }">
                      {{ item.created_at | moment("DD.MM.YYYY HH:mm") }}
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">
                        <v-card class="my-2">
                          <v-card-title>Ponuka SP</v-card-title>
                          <v-card-text>{{ item.ponuka }}</v-card-text>
                        </v-card>
                        <v-card class="my-2">
                          <v-card-title>Informácie o SP</v-card-title>
                          <v-card-text>
                            <socialny-podnik-profile :item="item.socialny_podnik" :editable="false" />
                          </v-card-text>
                        </v-card>
                      </td>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="'zaujem_dobrovolna_liecba' in form || 'zabezpecena_nadvazna_starostlivost' in form">
        <v-col>
          <v-card>
            <v-card-title>
              Oblasť závislosti
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-switch v-model="form.zaujem_dobrovolna_liecba"
                    label="Klient prejavil záujem o absolvovanie dobrovoľnej liečby"></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="auto">
                  <v-switch v-model="form.zabezpecena_nadvazna_starostlivost"
                    label="Klient má zabezpečenú nadväznú starostlivosť v:"></v-switch>
                </v-col>
                <v-col cols="auto">
                  <v-text-field v-model="form.zabezpecena_nadvazna_starostlivost_text" label="Organizácia/zariadenie"
                    :disabled="!form.zabezpecena_nadvazna_starostlivost"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-title>
              Spolupráca s obcou/mestom
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="auto">
                  <v-switch v-model="form.poziadal_o_spolupracu_obec"
                    label="Klient požiadal o spoluprácu obec/mesto:"></v-switch>
                </v-col>
                <v-col cols="auto">
                  <v-text-field v-model="form.poziadal_o_spolupracu_obec_text" label="Obec/mesto"
                    :disabled="!form.poziadal_o_spolupracu_obec"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="'zaujem_dobrovolna_liecba' in form">
        <v-col>
          <v-card>
            <v-card-title>
              HOLUP
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="auto">
                  <v-switch disabled v-model="form.reset_hesla" label="Klient už požiadal o reset hesla"></v-switch>
                </v-col>
                <v-col cols="auto" v-if="!form.reset_hesla">
                  <v-btn @click="passwordReset()">Požiadať o reset hesla</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="auto">
                  <v-switch disabled v-model="form.zivotopis_dostupny" label="Klient si vytvoril životopis"></v-switch>
                </v-col>
                <v-col v-if="form.zivotopis_dostupny" cols="auto">
                  <v-btn @click="downloadZivotopis()">Stiahnuť životopis (PDF)</v-btn>
                </v-col>

                <v-col v-if="form.zivotopis_dostupny" cols="auto">
                  <v-btn @click="downloadZivotopisDocx()">Stiahnuť životopis (DOCX)</v-btn>
                </v-col>

                <v-col v-if="form.zivotopis_dostupny" cols="auto">
                  <v-btn @click="downloadAllThree()">Stiahnuť všetko (PDF)</v-btn>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-layout v-if="!form.closed" pt-5>
        <v-btn class="ma-2" fixed right bottom dark rounded color="primary" @click="updateItem()">
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
      </v-layout>

      <v-snackbar v-model="snackbar_saved" color="success" :timeout="3000">
        Uložené
        <v-btn text @click="snackbar_saved = false"> Zavrieť </v-btn>
      </v-snackbar>
      <v-snackbar v-model="snackbar_error" color="error" :timeout="5000">
        Chyba
      </v-snackbar>

      <v-dialog v-model="dialog" width="800px">
        <v-card>
          <v-toolbar dark color="indigo">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
          </v-toolbar>
          <v-card>
            <v-card-text>{{ dialog_item.priklady }}</v-card-text>
          </v-card>
        </v-card>
      </v-dialog>
    </v-container>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="Swot" />
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";
import FormSkeleton from "../components/FormSkeleton.vue";
import SocialnyPodnikProfile from '../../socialne_podniky/components/SocialnyPodnikProfile.vue';

Vue.use(require("vue-moment"));
Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new",
  },

  components: {
    "form-skeleton-component": FormSkeleton,
    SocialnyPodnikProfile,
  },

  data: () => ({
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    expanded: [],
    dialog_item: {
      nazov: "",
      charakteristika: [],
      zdroj: [],
      poznamka: [],
      priklad: [],
    },

    socialne_podniky_headers: [
      {
        text: 'Dátum',
        value: 'created_at',
      },
      {
        text: 'Názov',
        value: 'socialny_podnik.kontaktne_udaje_nazov',
      },

      { text: 'Miesto', value: 'socialny_podnik.miesto_cinnosti_a_aktivit' },

      { text: 'Email', value: 'socialny_podnik.email' },
      { text: 'Stav', value: 'status' },
      { text: 'Služby', value: 'socialny_podnik.ubytovanie' },

      { text: 'Akcie', value: 'id' },
    ],

    form: {
      id: null,
      spravanie_vo_vtos_silne: "",
      spravanie_vo_vtos_slabe: "",
      spravanie_vo_vtos_prilezitosti: "",
      spravanie_vo_vtos_ohrozenia: "",

      rodina_silne: "",
      rodina_slabe: "",
      rodina_prilezitosti: "",
      rodina_ohrozenia: "",

      byvanie_silne: "",
      byvanie_slabe: "",
      byvanie_prilezitosti: "",
      byvanie_ohrozenia: "",

      vzdelanie_silne: "",
      vzdelanie_slabe: "",
      vzdelanie_prilezitosti: "",
      vzdelanie_ohrozenia: "",

      zamestnanie_silne: "",
      zamestnanie_slabe: "",
      zamestnanie_prilezitosti: "",
      zamestnanie_ohrozenia: "",

      financie_silne: "",
      financie_slabe: "",
      financie_prilezitosti: "",
      financie_ohrozenia: "",

      volny_cas_silne: "",
      volny_cas_slabe: "",
      volny_cas_prilezitosti: "",
      volny_cas_ohrozenia: "",

      pracovne_zrucnosti: "",
      socialny_podnik_dostupny: false,

      zaujem_dobrovolna_liecba: false,
      zabezpecena_nadvazna_starostlivost: false,
      zabezpecena_nadvazna_starostlivost_text: "",
      poziadal_o_spolupracu_obec: false,
      poziadal_o_spolupracu_obec_text: ""
    },

    selects: {
      nepravdive_zavadzajuce: [
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený UVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený NEUVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
      ],
    },

    manual: {
      spravanie_silne: {
        nazov: "Správanie vo VTOS - Silné stránky",
        priklady:
          "akceptácia autorít, schopnosť ovládať svoju agresivitu, triezvy pohľad na prijatie situácie, komunikatívnosť, zmysel pre humor, dobré vzťahy s ostatnými klientmi, spolupráca, schopnosť prijať pravidlá",
      },
      spravanie_slabe: {
        nazov: "Správanie vo VTOS - Slabé stránky",
        priklady:
          "ignorácia a nerešpektovanie autorít, neschopnosť sebaovládania, problematické vzťahy s ostatnými klientmi, pasivita, vnútorné neprijatie trestu",
      },
      spravanie_prilezitosti: {
        nazov: "Správanie vo VTOS - Príležitosti",
        priklady: "vhodné rozvojové aktivity a programy, pozitívne interakcie",
      },
      spravanie_ohrozenia: {
        nazov: "Správanie vo VTOS - Ohrozenia",
        priklady:
          "nevhodne zvolené aktivity a programy, nevhodné zaradenie klienta",
      },

      rodina_silne: {
        nazov: "Rodina, vzťahy a komunita - Silné stránky",
        priklady:
          "pozitívny vzťah k rodine, záujem o dieťa, pravidelná korešpondencia a kontakt s rodinou",
      },
      rodina_slabe: {
        nazov: "Rodina, vzťahy a komunita - Slabé stránky",
        priklady:
          "negatívny vzťah k rodine, nezáujem o dieťa, neschopnosť vychovávať dieťa, absentujúci kontakt s rodinou (osobný, písomný)",
      },
      rodina_prilezitosti: {
        nazov: "Rodina, vzťahy a komunita - Príležitosti",
        priklady:
          "funkčnosť rodinných vzťahov, vhodne zvolený program zameraný na rodinu, rodinné konferencie, sanačné programy, inštitút opustenia ústavu",
      },
      rodina_ohrozenia: {
        nazov: "Rodina, vzťahy a komunita - Ohrozenia",
        priklady:
          "dieťa so špeciálnymi potrebami, nefunkčnosť rodinných vzťahov",
      },

      byvanie_silne: {
        nazov: "Bývanie - Silné stránky",
        priklady:
          "vlastnícky vzťah k nehnuteľnosti, zodpovedný prístup k otázke bývania (platby načas, nájomná zmluva...)",
      },
      byvanie_slabe: {
        nazov: "Bývanie - Slabé stránky",
        priklady:
          "bezdomovectvo, opakovane vyhodený z domu, odchovanec DeD bez skúseností s vhodným bývaním",
      },
      byvanie_prilezitosti: {
        nazov: "Bývanie - Príležitosti",
        priklady:
          "zabezpečené bývanie (u rodičov, podnájom...), dostupné ubytovanie v rámci sociálnych služieb (útulky, nocľahárne, DSS)",
      },
      byvanie_ohrozenia: {
        nazov: "Bývanie - Ohrozenia",
        priklady:
          "nedostupné sociálne služby spojené s bývaním, nehnuteľnosť s ťarchou (hrozba dražby), nedostatok ekonomicky dostupného bývania, nereálne očakávania, návrat do kriminogénneho prostredia",
      },

      vzdelanie_silne: {
        nazov: "Vzdelanie - Silné stránky",
        priklady:
          "vysokoškolské vzdelanie, maturita, výučný list, absolvované kurzy, ochota vzdelávať sa",
      },
      vzdelanie_slabe: {
        nazov: "Vzdelanie - Slabé stránky",
        priklady:
          "nevzdelávateľný, negramotný, bez vzdelania, základné vzdelanie, slabá motivácia",
      },
      vzdelanie_prilezitosti: {
        nazov: "Vzdelanie - Príležitosti",
        priklady:
          "rekvalifikačné kurzy, možnosť ďalšieho vzdelávania (výučný list, maturita...)",
      },
      vzdelanie_ohrozenia: {
        nazov: "Vzdelanie - Ohrozenia",
        priklady:
          "nedostatok vhodných vzdelávacích príležitostí (kurzy...), nedostatočná podpora okolia",
      },

      zamestnanie_silne: {
        nazov: "Zamestnanie - Silné stránky",
        priklady:
          "trvalé pracovné návyky, pracovné skúsenosti, ochota cestovať za zamestnaním, ochota zmeniť zamestnávateľa",
      },
      zamestnanie_slabe: {
        nazov: "Zamestnanie - Slabé stránky",
        priklady: "bez pracovných návykov, neochota pracovať",
      },
      zamestnanie_prilezitosti: {
        nazov: "Zamestnanie - Príležitosti",
        priklady: "zabezpečené zamestnanie, prísľub práce",
      },
      zamestnanie_ohrozenia: {
        nazov: "Zamestnanie - Ohrozenia",
        priklady:
          "slabé finančné ohodnotenie práce, demotivujúce prostredie, nedostatok vhodných, pracovných príležitostí, vzdialenosť od bydliska",
      },

      financie_silne: {
        nazov: "Financie - Silné stránky",
        priklady:
          "finančná zabezpečenosť, poberateľ dôchodku, vysoká úroveň finančnej gramotnosti",
      },
      financie_slabe: {
        nazov: "Financie - Slabé stránky",
        priklady:
          "bez finančných prostriedkov, dlhy, exekúcie, vyživovacia povinnosť, gambling, nízka úroveň finančnej gramotnosti, vysoké nároky",
      },
      financie_prilezitosti: {
        nazov: "Financie - Príležitosti",
        priklady:
          "program finančnej gramotnosti, dedičské konanie, sociálne dávky",
      },
      financie_ohrozenia: {
        nazov: "Financie - Ohrozenia",
        priklady: "herne, úžera, vysoké životné náklady",
      },

      volny_cas_silne: {
        nazov: "Voľný čas - Silné stránky",
        priklady:
          "má záujmy, hobby, manuálne zručný (napr. práca s drevom, maľovanie, športovo zdatný...), hudobne nadaný",
      },
      volny_cas_slabe: {
        nazov: "Voľný čas - Slabé stránky",
        priklady: "bez záujmu, ambície nezodpovedajú potenciálu",
      },
      volny_cas_prilezitosti: {
        nazov: "Voľný čas - Príležitosti",
        priklady: "zmysluplné využitie voľného času – možný zdroj príjmu",
      },
      volny_cas_ohrozenia: {
        nazov: "Voľný čas - Ohrozenia",
        priklady: "nemá financie na hobby, málo podnetné prostredie",
      },
    },
  }),

  computed: {},

  created() {
    this.getItem();
  },

  methods: {
    passwordReset() {
      apiService.passwordReset(this.form.id, this.form.iapsz).then(
        () => {
          this.snackbar_saved = true;
          this.getItem();
          () => {
            this.snackbar_error = true;
          }

        },
      );
    },
    downloadZivotopis() {
      apiService.downloadIapszZivotopis(this.form.id, this.form.iapsz);
    },

    downloadZivotopisDocx() {
      apiService.downloadIapszZivotopisDocx(this.form.id, this.form.iapsz);
    },

    downloadAllThree() {
      apiService.downloadIapszAllThree(this.form.id, this.form.iapsz);
    },

    showInfo(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },

    acceptItem(item) {
      apiService.acceptSocialnyPodnikZaujem(item).then(() => { this.getItem() });
    },

    rejectItem(item) {
      apiService.rejectSocialnyPodnikZaujem(item).then(() => { this.getItem() });
    },

    getItem() {
      this.loading = true;
      apiService.getIapszSwot(this.$route.params.id).then((response) => {
        this.form = response;
        this.loading = false;
      });
    },
    updateItem() {
      apiService.updateIapszSwot(this.form, this.$route.params.id).then(
        (response) => {
          this.snackbar_saved = true;
          this.form = response;
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },
  },
};
</script>